<template>
<div class="body apply">
    <div class="wrap" style="width: inherit !important;">
        <div class="apply-menu-wrap1" :style="[classList.length > 1 ? {'display': 'none'} : {}]">
            <div class="top-menu">
                <h1>
                    <img v-if="logo" :src="logo" alt="company logo">
                    <div v-else style="height: 25px;"/>
                    <!-- <span>사내어학과정</span> -->
                    <div style="height:30px;"></div>
                </h1>
                <!-- 모바일용 -->
                <a href="#" class="dp-inblock-m m-menu" id="header-menu-btn">
                    <img src="../../assets/img/m_gnb_sub.png" alt="menu">
                </a>
                <ul>
                    <li class="on-blue">
                        <a>신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
            <!-- 반응형 메뉴 -->
            <div class="dp-inblock-m m-top-menu" id="header-menu">
                <a href="#" class="close" id="header-close">
                    <img src="../../assets/img/menu_close.png" alt="">
                </a>
                <ul class="clear">
                    <li><a class="pointer">신청하기</a></li>
                    <li><a class="pointer">신청내역 확인</a></li>
                    <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
                    <li><a class="pointer">Logout</a></li>
                </ul>
            </div>
        </div>
        <!-- 등록 갯수가 2개 이상일 때 노출  -->
        <div class="apply-menu-wrap2 dp-none-m" :style="[classList.length <= 1 ? {'display': 'none'} : {}]">
            <div class="left-menu">
                <ul>
                    <li>
                        <h1>
                            <!-- <img src="../../assets/img/logo/samsungsdi.png" alt="company logo">
                            <span>사내어학과정</span> -->
                            <div style="height:30px;"></div>
                        </h1>
                    </li>
                    <li class="pointer" :class="{'on-blue': classIdx === item.idx}" v-for="(item, index) of classList" :key="index" @click="selectClass(item.idx, index)">
                        <a>{{item.class_name}}</a>
                    </li>
                </ul>
            </div>
            <div class="top-menu">
                <ul>
                    <li class="on-blue">
                        <a class="pointer">신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li>
                    <a href="">비밀번호 재설정</a>
                </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="con">
            <div class="title">
                <h2>{{program.program_name}}</h2>
                <span class="all-program float-right pointer">전체과정 상세보기</span>
                <p><br></p>
            </div>
            <progress-bar></progress-bar>
            <div class="mt-50">
                <div class="apply-program-wrap">
                    <div class="apply-program">
                        <!-- 강의 검색이 있을 경우 -->
                        <div class="apply-program-search">
                            <h3>강의검색
                                <span>원하시는 강의 선택을 위해 검색 조건을 설정해주세요.</span>
                                <span class="minus">
                                    <label for="checkbox"></label>
                                    <input type="checkbox" name="" id="">
                                    <span class="ml-05">마감된 과정 제외</span>
                                </span>
                            </h3>
                            <div class="search">
                                <ul v-if="isEmptyItem(language)">
                                    <li class="search-title">언어</li>
                                    <li v-for="(item, index) of language" :key="index">
                                        <label for="">
                                            <input type="checkbox" class="mr-05" v-model="item.value" name="" id="">
                                            <span class="mr-05">{{item.key}}</span>
                                        </label>
                                    </li>
                                </ul>
                                <ul v-if="isEmptyItem(place)">
                                    <li class="search-title">지역</li>

                                    <li v-for="(item, index) of place" :key="index">
                                        <label for="">
                                            <input type="checkbox" class="mr-05" v-model="item.value" name="" id="">
                                            <span class="mr-05">{{item.key}}</span>
                                        </label>
                                    </li>
                                </ul>
                                <ul>
                                    <li class="search-title">시간</li>
                                    <li v-for="(item, index) of subjectTime" :key="index">
                                        <label for="">
                                            <input type="checkbox" class="mr-05" v-model="item.value" name="" id="">
                                            <span class="mr-05">{{item.key}}</span>
                                        </label>
                                    </li>
                                </ul>
                                <ul>
                                    <li class="search-title">요일</li>
                                    <li v-for="(item, index) of day" :key="index">
                                        <label for="">
                                            <input type="checkbox" class="mr-05" v-model="item.value" name="" id="">
                                            <span class="mr-05">{{item.key}}요일</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                            <div class="apply-btn">
                                <button @click="searchClass()">검색</button>
                            </div>
                        </div>
                        <!-- 강의 검색이 있을 경우 finish -->

                        <div class="apply-program-select">
                            <!-- 과정 전체가 선착순일 경우 -->
                            <!-- <div v-if="faMain.faType === 'AF'" class="apply-first-com"> -->
                            <div v-if="faMain.faType === 'AF'" class="apply-first-com">
                                <ul class="boad-none">
                                    <li>
                                        <span>모집 : <b class="bold">{{faMain.faNum}}</b></span>
                                    </li>
                                    <li>
                                        <span>잔여 : <b class="bold">{{faMain.faNum - faMain.applicantNum}}명</b></span>
                                    </li>
                                    <li>
                                        <span class="bold" v-if="faMain.waitingNum && faMain.waitingNum !== 0">대기 신청 가능</span>
                                        <span class="bold" v-else>대기 신청 불가능</span>
                                    </li>
                                </ul>
                            </div>
                            <!-- 과정 전체가 선착순일 경우 finish -->

                            <div class="apply-program-unit-wrap">
                                <ul>
                                    <!-- 선택 전 -->
                                    <li v-for="(item, index) of sugangList" :key="index" class="program-info" :class="{'program-select blue': item.selected}">
                                        <div class="apply-program-unit-check">
                                            <label for="">
                                                <input type="checkbox" v-model="item.selected" name="" id="">
                                            </label>
                                        </div>
                                        <div class="apply-program-unit">
                                            <div v-if="item.faNum !== 0 && item.faType === 'SF'" class="apply-first-com">
                                                <!-- <div v-if="item.faNum !== 0 && item.faType === 'SF'" class="apply-first-com"> -->
                                                <ul>
                                                    <li>
                                                        <span>모집 : <b class="bold">{{item.faNum}}</b></span>
                                                    </li>
                                                    <li class="txt-red">
                                                        <span>잔여 : <b class="bold">{{item.faNum - item.applicantNum}}</b></span>
                                                    </li>
                                                    <li v-if="item.restYn === 'Y'">
                                                        <span class="bold">대기 신청 가능</span>
                                                    </li>
                                                    <li v-else-if="item.restYn === 'N'">
                                                        <span class="bold">대기 신청 불가능</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <ul>
                                                <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                                                <li class="unit-title blue" :class="{'pt-00': item.faType !== 'SF'}">
                                                    <h4>{{item.subjectName}}</h4>
                                                </li>
                                                 <li>
                                                    <p v-for="(item, index) of viewItemList(item)" :key="index">
                                                        <span>{{item.key || '-'}} <b class="bold">{{item.value || '-'}}</b></span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="apply-result">
                        <h3>선택 내역 <span class="dp-inblock-m">(2)</span></h3>
                        <ul class="result-box">
                            <!-- 반응형일 때만 가려짐 -->
                            <li class="dp-block-m">
                                <p>
                                    * 수강신청 완료 후 반드시 수강신청내역 확인을 진행해주시기 바랍니다. <br>
                                    * 수강 취소를 원하시는 경우 수강신청 내역 확인 메뉴에서 진행해주시기 바랍니다. <br>
                                    * 기간 외 신청은 불가합니다.
                                </p>
                            </li>
                            <li v-for="(item, index) of paymentList" :key="index">
                                <p>{{item.subjectName}}</p>
                                <span>{{numberFormat(item.bookPrice + item.eduPrice)}}원</span>
                            </li>
                            <li class="total">
                                <p>총 금액 <span class="txt-red">{{numberFormat(totalPayment)}}원</span></p>
                            </li>
                            <li class="apply-btn pointer">수강신청</li>
                        </ul>
                        <!-- 반응형일 때만 -->
                        <div class="notice dp-none-m">
                            <p>
                                * 수강신청 완료 후 반드시 수강신청내역 확인을 진행해주시기 바랍니다. <br>
                                * 수강 취소를 원하시는 경우 수강신청 내역 확인 메뉴에서 진행해주시기 바랍니다. <br>
                                * 기간 외 신청은 불가합니다.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'

export default {
    data: () => ({
        isDetailModalOpened: false,

        classIdx: '', // 현재 선택된 클래스 아이디
        classNum: 0, // 현재 선택된 클래스 순서번호

        // 언어 검색 쿼리
        language: [],
        place: [],
        subjectTime: [{
                key: '오전',
                value: false
            },
            {
                key: '점심',
                value: false
            },
            {
                key: '저녁',
                value: false
            }
        ],

        day: [{
                key: '월',
                value: false
            },
            {
                key: '화',
                value: false
            },
            {
                key: '수',
                value: false
            },
            {
                key: '목',
                value: false
            },
            {
                key: '금',
                value: false
            },
            {
                key: '토',
                value: false
            },
            {
                key: '일',
                value: false
            },
        ],

        // 선착순, 잔여, 대기자 정보
        faMain: {
            value: false,
            faNum: 0,
            faType: 'N',
            waitingNum: '', // 대기자 계산
            restYn: '', // 잔여인원 표시여부
            applicantNum: '' // 신청자수
        },

        program: {}, // 프로그램 옵션 데이터
        classList: [], // 과목명 리스트
        subjectAllList: [], // 프로그램 전체 수업 리스트
        subjectList: [], // 한 과목의 수업 리스트
        sugangList: [], // 수강 신청 리스트
        selectedList: [], // 선택된 수강 신청 index

        paymentList: [], // 구매할 수강 내역
        totalPayment: 0, // 총 금액

        parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
        changeClass: false, // 클래스 변경중인지 아닌지
        studentSubjectList: [],

        logo: '' // 미리보기 로고 url용
    }),

    watch: {
        sugangList: {
            handler() {
                console.log('this.changeClass', this.changeClass)
                if (this.changeClass) {
                    this.changeClass = false

                    if (this.program.subject_dup_type !== 'X') {
                        var count = 0
                        for (var item of this.sugangList) {
                            if (item.selected) {
                                if (count < 1) {
                                    count += 1
                                }
                            } else {
                                if (count > 0) {
                                    console.log('notvaliditem', item)
                                    item.notValid = true
                                } else {
                                    console.log('deleteitem', item)
                                    item.notValid = false
                                }
                            }
                        }

                        for (var item of this.sugangList) {
                            if (!item.selected) {
                                if (count > 0) {
                                    console.log('notvaliditem', item)
                                    item.notValid = true
                                } else {
                                    item.notValid = false
                                }
                            }
                        }
                    } else {
                        this.paymentList = []
                        this.totalPayment = 0
                        for (var item of this.sugangList) {
                            if (item.selected) {
                                item.selected = false
                            }
                        }
                    }

                    return false
                }

                if (this.program.subject_dup_type === 'O') {
                    // this.paymentList = []
                    // this.totalPayment = 0
                    for (var item of this.sugangList) {
                        if (item.selected) {
                            var count = 0
                            for (var payment of this.paymentList) {
                                if (payment.subjectIdx === item.subjectIdx) {
                                    count += 1
                                }
                            }

                            if (count === 0) {
                                this.paymentList.push(item)
                                this.totalPayment += item.eduPrice
                                this.totalPayment += item.bookPrice
                            }
                        } else {
                            for (var [index, payment] of this.paymentList.entries()) {
                                if (payment.subjectIdx === item.subjectIdx) {
                                    this.totalPayment -= item.eduPrice
                                    this.totalPayment -= item.bookPrice
                                    this.paymentList.splice(index, 1)
                                }
                            }
                        }
                    }
                } else if (this.program.subject_dup_type === 'N') {
                    var count = 0
                    for (var item of this.sugangList) {
                        if (item.selected) {
                            if (count < 1) {
                                this.paymentList.push(item)
                                this.totalPayment += item.eduPrice
                                this.totalPayment += item.bookPrice
                                count += 1
                            }
                        } else {
                            if (count > 0) {
                                console.log('notvaliditem', item)
                                item.notValid = true
                            } else {
                                for (var [index, payment] of this.paymentList.entries()) {
                                    if (payment.subjectIdx === item.subjectIdx) {
                                        this.totalPayment -= item.eduPrice
                                        this.totalPayment -= item.bookPrice
                                        this.paymentList.splice(index, 1)
                                    }
                                }
                                console.log('deleteitem', item)
                                item.notValid = false
                            }
                        }
                    }

                    for (var item of this.sugangList) {
                        if (!item.selected) {
                            if (count > 0) {
                                console.log('notvaliditem', item)
                                item.notValid = true
                            } else {
                                item.notValid = false
                            }
                        }
                    }
                } else {
                    var count = 0
                    for (var item of this.sugangList) {
                        if (item.selected) {
                            if (count < 1) {
                                this.paymentList.push(item)
                                this.totalPayment += item.eduPrice
                                this.totalPayment += item.bookPrice
                                count += 1
                            }
                        } else {
                            if (count > 0) {
                                console.log('notvaliditem', item)
                                item.notValid = true
                            } else {
                                for (var [index, payment] of this.paymentList.entries()) {
                                    if (payment.subjectIdx === item.subjectIdx) {
                                        this.totalPayment -= item.eduPrice
                                        this.totalPayment -= item.bookPrice
                                        this.paymentList.splice(index, 1)
                                    }
                                }
                                console.log('deleteitem', item)
                                item.notValid = false
                            }
                        }
                    }

                    for (var item of this.sugangList) {
                        if (!item.selected) {
                            if (count > 0) {
                                console.log('notvaliditem', item)
                                item.notValid = true
                            } else {
                                item.notValid = false
                            }
                        }
                    }
                }

                for (var item of this.sugangList) {
                    for (var subject of this.subjectAllList) {
                        if (subject.subjectIdx === item.subjectIdx) {
                            subject.selected = item.selected
                        }
                    }
                }

                console.log('this.paymentList', this.paymentList)
            },
            deep: true
        }
    },

    mounted() {
        var oParams = GetUrlParams()
        this.pageIdx = oParams.pageIdx

        var programIdx = this.pageIdx
        var params = {
            programIdx: programIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/program/${programIdx}`, {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.program = res.data.program
                this.classList = res.data.classList
                this.subjectAllList = res.data.subjectList
                this.logo = res.data.main.company_logo_file_url

                // 등록된 클래스가 존재할 때 처음 클래스를 기본 클래스로 지정
                if (this.classList.length > 1) {
                    this.classIdx = this.classList[0].idx
                }

                // backend Response가 카멜, 스네이크 명명법이 섞여있어서 키값 파싱
                for (var item of this.subjectAllList) {
                    var tempObj = {}
                    // 과정 전체 선착순일때 세팅
                    if (!this.faMain.value) {
                        if (item.faType === 'AF') {
                            this.faMain.value = true
                            this.faMain.faNum = item.faNum
                            this.faMain.faType = item.faType
                            this.faMain.restYn = item.restYn
                            this.faMain.waitingNum = item.waitingNum
                            this.faMain.applicantNum = item.applicantNum
                        }
                    }

                    for (var key in item) {
                        // 언어 체크박스용 어레이 생성
                        if (key === 'language') {
                            this.language.push({
                                key: item[key],
                                value: false
                            })
                        }

                        if (key === 'place') {
                            this.place.push({
                                key: item[key],
                                value: false
                            })
                        }

                        tempObj[key] = item[key]
                    }
                    this.subjectList.push(tempObj)
                }

                // this.sugangList = JSON.parse(JSON.stringify(this.subjectList))

                 var sugangList = []
                var initClassIdx = this.classList[0].idx
                for (var item of this.subjectList) {
                    if (item.idxItmSugangClass === initClassIdx) {
                        sugangList.push(item)
                    }
                }

                this.sugangList = JSON.parse(JSON.stringify(sugangList))
            } else {
                alert(res.data.result)
            }
        }).catch(err => {
            // alert('세션이 종료되었습니다. \n로그인 페이지로 이동합니다.')
            // this.$router.push('/user/login')
            console.log(err)
        })
    },

    methods: {
        // 프로그램 등록에서 선택한 컬럼만 출력되게
        viewItemList(data) {
            if (data.columnOrder) {
                var itemList = data.columnOrder.split('^')
                var returnItemList = []
                for (var item of itemList) {
                    if (item === '언어') {
                        returnItemList.push({
                            key: item,
                            value: data.language
                        })
                    } else if (item === '장소') {
                        returnItemList.push({
                            key: item,
                            value: data.place
                        })
                    } else if (item === '요일') {
                        if (data.day && typeof data.day === 'string') {
                            returnItemList.push({
                                key: item,
                                // ie11에서 replaceAll 지원안해서 해당 코드로 진행
                                value: data.day.replace(/\^/gi, "")
                            })
                        }
                    } else if (item === '교육시간') {
                        returnItemList.push({
                            key: item,
                            value: data.subjectStartTime + '~' + data.subjectEndTime
                        })
                    } else if (item === '교육비') {
                        returnItemList.push({
                            key: item,
                            value: data.eduPrice
                        })
                    } else if (item === '교재비') {
                        returnItemList.push({
                            key: item,
                            value: data.bookPrice
                        })
                    }
                }

                return returnItemList
            } else {
                return []
            }
            console.log('data', data)
            return ['']
        },

        // 컬럼값이 비었는지 확인
        isEmptyItem(data) {
            var count = 0
            for (var item of data) {
                if (item.key === '') {
                    continue
                } else {
                    count += 1
                }
            }

            if (count > 0) {
                return true
            } else {
                return false
            }
        },

        // 왼쪽 탭의 클래스 선택시 (idx는 과목의 인덱스, index는 왼쪽 탭의 순서번호)
        selectClass(idx, index) {
            if (this.classIdx !== idx) {
                this.classIdx = idx
                this.classNum = index
                this.resetSearch()
                this.changeSearchItem(index)
            }
        },

        // 왼쪽 탭의 클릭한 수업으로 리스트 변경
        changeSearchItem(index) {
            // 수업 리스트, 언어-지역 검색쿼리 빈 값으로 초기화
            this.subjectList = []
            this.language = []
            this.place = []

            var sugangList = []
            console.log('this.classList', this.classList)
            var initClassIdx = this.classList[index].idx
            for (var item of this.subjectAllList) {
                if (item.idxItmSugangClass === initClassIdx) {
                    sugangList.push(item)
                }
            }

            // backend Response가 카멜, 스네이크 명명법이 섞여있어서 키값 파싱
            for (var item of sugangList) {
                var tempObj = {}

                for (var key in item) {
                    // 과정 전체 선착순일때 세팅
                    if (item.faType === 'AF') {
                        this.faMain.value = true
                        this.faMain.faNum = item.faNum
                        this.faMain.faType = item.faType
                        this.faMain.restYn = item.restYn
                        this.faMain.watingNum = item.watingNum
                        this.faMain.applicantNum = item.applicantNum
                    }

                    // 언어 체크박스용 어레이 생성
                    if (this.snakeToCamelCase(key) === 'language') {
                        this.language.push({
                            key: item[key],
                            value: false
                        })
                    }

                    if (this.snakeToCamelCase(key) === 'place') {
                        this.place.push({
                            key: item[key],
                            value: false
                        })
                    }

                    tempObj[this.snakeToCamelCase(key)] = item[key]
                }
                this.subjectList.push(tempObj)
            }

            this.sugangList = JSON.parse(JSON.stringify(this.subjectList))
        },

        // 검색 쿼리 초기화
        resetSearch() {
            var tempArray = ['language', 'place', 'subjectTime', 'day']
            for (var variable of tempArray) {
                for (var item of this[variable]) {
                    item.value = false
                }
            }
        },

        // 스네이크케이스 => 카멜케이스 변환
        snakeToCamelCase(key) {
            var camelCased = key.replace(/_([a-z])/g, function (g) {
                return g[1].toUpperCase();
            });
            return camelCased
        },

        // 강의검색
        searchClass() {
            // TODO: 추후에 각 idx에 맞게 변경해야됨
            var classIdx = this.classIdx
            var params = {
                classIdx: classIdx,
                language: this.convertQuery(this.language),
                place: this.convertQuery(this.place),
                subjectTime: this.convertQuery(this.subjectTime),
                day: this.convertQuery(this.day),
            }

            this.axios.get(this.axios.root + this.axios.port + `/program/search-subject/${classIdx}`, {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.sugangList = []
                    for (var item of res.data.sugangList) {
                        item['selected'] = false
                        this.sugangList.push(item)
                    }
                }
            })
        },

        // 체크박스 형태 오브젝트 => 영어/중국어/일본어 String 형태로 변경
        convertQuery(array) {
            var tempArray = []

            for (var item of array) {
                if (item.value) {
                    tempArray.push(item.key)
                }
            }

            tempArray = tempArray.join('/')
            return tempArray
        },

        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // 전체과정 상세보기 윈도우 팝업 열기
        // 파일 위치는 components/reg/detail.vue
        openPopup() {
            let routeData = this.$router.resolve({
                name: 'reg-apply-detail',
                query: {
                    programIdx: 1
                }
            });
            window.open(routeData.href, 'window팝업', 'width=1200, height=650, top:100, left:100, menubar=no, status=no, toolbar=no')
        },

        // 과정 상세보기 레이어팝업 열기
        openModal(data) {
            this.parentData = data
            this.isDetailModalOpened = true
        },

        // 모달 닫기
        closeModal() {
            this.isDetailModalOpened = false
        }
    }
}
</script>
